import { useEffect, useState } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export function useVisitorId() {
  const [visitorId, setVisitorId] = useState(null);

  useEffect(() => {
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setVisitorId(result.visitorId);

      if (typeof window !== "undefined" && "clarity" in window) {
        // @ts-ignore
        window.clarity("set", "visitor_id", result.visitorId);
      }
    };

    loadFingerprint();
  }, []);

  return visitorId;
}
